<template>
    <div class="block-editor appstore-delete-review-response">
        <section>
            <div class="title">Channel ID</div>
            <TiptapEditor placeholder="App Store Channel ID" :show-attributes="true" v-model="clone.channelId" automation-mode />
            <small>Yanıtı silinecek yorumun bulunduğu kanal ID'si</small>
        </section>
        <section>
            <div class="title">Review ID</div>
            <TiptapEditor placeholder="App Store Review ID" :show-attributes="true" v-model="clone.reviewId" automation-mode />
            <small>Yanıtı silinecek yorumun ID'si</small>
        </section>
        <section class="warning">
            <a-alert
                message="Dikkat"
                description="Bu işlem yoruma verilen yanıtı kalıcı olarak silecektir."
                type="warning"
                show-icon
            />
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "AppStoreDeleteReviewResponse",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                channelId: "",
                reviewId: "",
                ...this.value
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.appstore-delete-review-response {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    small {
        color: #777;
    }

    .warning {
        margin-top: 10px;
    }
}
</style>
